module.exports = __webpack_public_path__ + "img/logo-latola.66f0913f.png";